import { Component } from '@angular/core';

@Component({
  selector: 'app-rigth-dobble-arrow-svg-icon',
  templateUrl: './rigth-dobble-arrow-svg-icon.component.html',
  styleUrls: [],
})
export class RigthDobbleArrowSvgIconComponent {}
